import { createContext, useContext, ReactNode } from 'react';
import { User, UseUserResult, PromoCode } from '../types';
import { useUser as useUserHook } from '../hooks/useUser';

const UserContext = createContext<UseUserResult | null>(null);

export function UserProvider({
  children,
  initialData,
  initialPromoCodes,
}: {
  children: ReactNode;
  initialData?: User | null;
  initialPromoCodes?: Record<string, PromoCode>;
}) {
  const { user: fetchedUser, promoCodes: fetchedPromoCodes, giftClaims, loading, error, refreshPromoCodes } = useUserHook();
  // If initialData is explicitly provided (including null for no user), use it; otherwise use fetched user
  const user = initialData !== undefined ? initialData : fetchedUser;
  const promoCodes = initialPromoCodes !== undefined ? initialPromoCodes : fetchedPromoCodes;

  return (
    <UserContext.Provider value={{ user, promoCodes, giftClaims, loading, error, refreshPromoCodes }}>
      {children}
    </UserContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}
